import { render, staticRenderFns } from "./PricingPlanSingle.vue?vue&type=template&id=efed28fc&scoped=true&"
import script from "./PricingPlanSingle.vue?vue&type=script&lang=js&"
export * from "./PricingPlanSingle.vue?vue&type=script&lang=js&"
import style0 from "./PricingPlanSingle.vue?vue&type=style&index=0&id=efed28fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efed28fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
